{
  "nav": {
    "mainNavigation": "Main navigation",
    "messages": "Messages",
    "templates": "Templates",
    "connectedSystems": "Connected Systems",
    "sectionSettings": "Settings",
    "settings": "Settings",
    "users": "Users",
    "groups": "Groups",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "toggleSidebarHint": "Toggle navigation"
  },
  "sidebar": {
    "toggle": "Toggle sidebar",
    "toggleHint": "Show or hide the menu",
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "brand": "Al-Musafer"
}
